import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavbarHeightService {
  readonly navbarHeight = signal(50);

  setValue(height: number): void {
    this.navbarHeight.set(height);
  }
}
